import React from 'react';
import { Paragraph } from '@sb1/ffe-core-react';
import { getNotMatchText } from './translations';
export function NoMatch(_a) {
    var noMatch = _a.noMatch, noMatchMessageId = _a.noMatchMessageId, listToRender = _a.listToRender, locale = _a.locale;
    return (React.createElement("div", null, noMatch.text ? (React.createElement("div", { className: "ffe-searchable-dropdown__no-match" },
        React.createElement(Paragraph, { id: noMatchMessageId }, noMatch.text))) : (listToRender.length === 0 && (React.createElement(Paragraph, { id: noMatchMessageId, className: "ffe-screenreader-only" }, getNotMatchText(locale))))));
}
